import React from 'react'
import { Typography } from '@mui/material'
import { usePanelPatientUid } from '../../dashboard/panelContext'
import { formatDayTime, toIso } from '../../format'
import { advancedColors } from '../../theme'
import { FieldRow, FieldSection, LabeledText, noop } from '../fieldPrimitives'
import { usePatientRecord } from './usePatientRecord'

// Every field here is read-only upstream — there is nothing for this card to write.
const PrimaryCareProviderPanel = () => {
  const uid = usePanelPatientUid()
  const { patient } = usePatientRecord(uid)
  const pcp = patient?.primaryCareProvider

  return (
    <FieldSection>
      {pcp?.hasPrimaryCareProvider === false && (
        <Typography variant="body2" sx={{ color: advancedColors.amber }}>
          Patient explicitly declined to provide PCP details
        </Typography>
      )}
      {pcp?.hasPrimaryCareProvider == null && (
        <Typography variant="body2" sx={{ color: advancedColors.inkMuted }}>
          Patient has not yet answered whether they have a PCP
        </Typography>
      )}
      <FieldRow columns={2}>
        <LabeledText label="Clinic Name" value={pcp?.clinicName ?? ''} onChange={noop} disabled />
        <LabeledText label="Clinic Address" value={pcp?.address ?? ''} onChange={noop} disabled />
      </FieldRow>
      <FieldRow columns={2}>
        <LabeledText label="Physician Name" value={pcp?.physicianName ?? ''} onChange={noop} disabled />
        <LabeledText label="Physician/Clinic Phone" value={pcp?.phone ?? ''} onChange={noop} disabled />
      </FieldRow>
      <FieldRow columns={2}>
        <LabeledText label="Clinic Website" value={pcp?.website ?? ''} onChange={noop} disabled />
        <LabeledText
          label="Consent Given At"
          value={formatDayTime(toIso(pcp?.consentGivenAt))}
          onChange={noop}
          disabled
        />
      </FieldRow>
    </FieldSection>
  )
}

export default PrimaryCareProviderPanel
